<!--suppress ALL -->
<template>
  <g-field :label="label" :type="type" :message="message">
    <g-field is-grouped>
      <g-select @change="onSelected" is-fullwidth :value="posNama || ''"
                :placeholder="posPembayarans.length === 0 ? $t('text.no_content_loaded') :
                `${placeholder}`" class="control is-expanded"
                :disabled="provinsiId === 0">
        <option v-for="posKeuangan in posPembayarans"
                :value="posKeuangan.nama" :key="posKeuangan.id">
          {{ posKeuangan.nama }}
        </option>
      </g-select>
      <div v-if="isLoading" class="control">
        <g-button type="light">
          <span class="icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
        </g-button>
      </div>
    </g-field>
  </g-field>
</template>

<script lang="ts">
import {Component, Vue, Prop} from 'annotation';
import {cloneDeep} from 'lodash';

import PosPembayaran from "../../../entity/PosPembayaran";
import Store from "../../../util/Store";

@Component
export default class PosPembayaranSelect extends Vue {

  @Prop({default: "", type: String})
  public posNama: string;

  @Prop({default: "Pos Pembayaran", type: String})
  public label: string;

  @Prop({default: "Pos Pembayaran", type: String})
  public placeholder: string;

  @Prop({type: String, default: null})
  public type: any;

  @Prop({type: String, default: null})
  public message: any;

  public get posPembayarans() {
    let posts: Array<PosPembayaran> = Store.getVmProperty('posPembayaran.data', []);
    return posts;
  }

  public isLoading: boolean = false;

  public created() {
    Store.dispatchPosPembayaran();
  }

  public onSelected(nama: string) {
    const posPembayaran: PosPembayaran = this.posPembayarans.find((item: PosPembayaran) => item.nama === nama) ||
      new PosPembayaran();

    this.$emit('pos-selected', cloneDeep(posPembayaran));
  }
}
</script>
